// extracted by mini-css-extract-plugin
export default {"iconsContainer":"socialMedia_iconsContainer__rOBGp","vertical":"socialMedia_vertical__pPjgw","iconContainer":"socialMedia_iconContainer__cSl1Y","icon":"socialMedia_icon__4XIng"};